import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

class TimePicker extends React.Component {

  state = {
    showOptions: false,
    selectedTime: moment('00:00', "HH:mm"),
  };

  componentWillMount() {
    if (this.props.defaultTime)
      this.setState({selectedTime: moment(this.props.defaultTime, "HH:mm")})
  }

  componentWillReceiveProps(next) {
    if (next.defaultTime)
      this.setState({selectedTime: moment(next.defaultTime, "HH:mm")})
  }

  setTime = (selectedTime) => {
    this.setState({selectedTime}, () => {
      this.props.onNewTime(selectedTime.format("HH:mm"))
    })
  };

  createTime = (type) => {
    const result = [];
    for (let i = 0; i < 24; i++) {
      result.push(
        <li
          className="tour-schedule__dates-time-item"
          key={`tp-key-${i}-${type}`}
          role="presentation"
          onClick={() => this.setTime(moment(`${i}:00`, "HH:mm"))}
        >
          {moment(`${i}:00`, "HH:mm").format("LT")}
        </li>
      );
      result.push(
        <li
          className="tour-schedule__dates-time-item"
          key={`tp-key-${i}:00-${type}`}
          role="presentation"
          onClick={() => this.setTime(moment(`${i}:30`, "HH:mm"))}
        >
          {moment(`${i}:30`, "HH:mm").format("LT")}
        </li>
      )
    }
    return result
  };

  render() {
    const {showOptions, selectedTime} = this.state;

    return (
      <div
        className="tour-schedule__dates-time-block"
        role="presentation"
        onClick={() => this.setState({showOptions: !showOptions})}
      >
        <div className="tour-schedule__dates-time-group">
          <i className="fa fa-clock-o" aria-hidden="true" />
          <p>{selectedTime.format("LT")}</p>
        </div>
        {
          showOptions ?
            <div className="tour-schedule__dates-time-wrap">
              <ul className="tour-schedule__dates-time-list scroll">
                {this.createTime()}
              </ul>
            </div>
            : null
        }
      </div>
    )
  }
}

TimePicker.propTypes = {
  onNewTime: PropTypes.func,
  defaultTime: PropTypes.string,
}

export default TimePicker;


// WEBPACK FOOTER //
// ./src/app/containers/Vendor/Tour/components/TimeSlots/TimePicker.js